export default "__VITE_ASSET__CIRVEE1n__"